import grid from '@assets/images/grid.svg';
import log_out from '@assets/images/log_out.svg';
import { TextView } from '@components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/actions';
import { useLogout } from '../../services/mutations';
import * as Styled from './styles';
import { ASSETS } from '../../utils/config';
import { isUserLoggedIn } from '../../utils/helpers';
import FeedbackModal from '../FeedbackModal';
import NewWheelPopup from '../NewWheelPopup';
import SearchBar from '../SearchBar';
import UserImage from '../UserImage';
import ReferralsIcon from 'assets/images/referrals-icon.svg';
import WaitlistFormModal from '../WaitlistModal';
import { resetGallery } from '../../redux/reducers/gallery';
import { clearGalleryPopup } from '../../redux/reducers/galleryPopup';
import { getLoggedInUser } from '../../utils/helpers';
import { EnterBetaButton } from '../EnterBetaButton';

const Navbar = ({ onYugaLogoClick }) => {
  const { userProfile } = useSelector((state) => state.userProfile);

  const [openWheelPopup, setOpenWheelPopup] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [isLoggingOut, setisLoggingOut] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [openWaitlistModal, setOpenWaitlistModal] = useState(false);

  const userType = userProfile?.referral_type;

  let nav = useNavigate();
  const dispatch = useDispatch();
  let userLogout = useLogout();
  const dropdownRef = useRef();

  const handleCloseWheelPopup = () => {
    setOpenWheelPopup(false);
  };

  const handleLogout = () => {
    setisLoggingOut(true);
    userLogout.mutate(null, {
      onSuccess: (response) => {
        setisLoggingOut(false);
        dispatch(logout());
        dispatch(resetGallery());
        dispatch(clearGalleryPopup());
        localStorage.removeItem('keyCloak');
        sessionStorage.removeItem("referralData");
        nav('/login');
      },
      onError: (err) => {
        setisLoggingOut(false);
      },
    });
  };

  const onClickLogo = () => {
    if (isUserLoggedIn()) nav(`/gallery/${getLoggedInUser().id}`);
    else nav('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        setClicked(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <Styled.Container>
      <Styled.LeftContainer>
        <Styled.Logo
          onClick={() => (onYugaLogoClick ? onYugaLogoClick() : onClickLogo())}
          src={ASSETS.iyugaLogo}
        ></Styled.Logo>
        <Styled.SearchBar>
          <SearchBar />
        </Styled.SearchBar>
      </Styled.LeftContainer>
      <Styled.CenterContainer>
        {/* <Styled.CreateWheelContainer onClick={() => setOpenWheelPopup(true)}>
          <Styled.CreateWheelImage src={ASSETS.createWheelNav} />
        </Styled.CreateWheelContainer> */}
      </Styled.CenterContainer>
      <Styled.RightContainer>
        {/* {isUserLoggedIn() ? (
          <Styled.InviteContainer onClick={() => nav("/invite")}>
            Invite Friends
          </Styled.InviteContainer>
        ) : null} */}

        {!!sessionStorage.getItem('referralData') && (
          <EnterBetaButton onClickBeta={() => setOpenWaitlistModal(true)} />

          // <Styled.Beta
          //   src={ASSETS.beta}
          //   onClick={() => setOpenWaitlistModal(true)}
          // />
        )}
        <Styled.UserContainer
          clicked={clicked}
          ref={dropdownRef}
          onClick={() => {
            setClicked(true);
            isUserLoggedIn() && setShowDropdown(!showDropdown);
          }}
        >
          {isUserLoggedIn() ? (
            <>
              <UserImage style={{ marginRight: 10 }} image={userProfile?.profile_image} size={42} />
              {isLoggingOut ? (
                <Styled.LoggingOut variant="subtitle">Logging Out...</Styled.LoggingOut>
              ) : (
                <>
                  <TextView variant="subtitle">
                    {userProfile?.first_name} {userProfile?.last_name}
                  </TextView>
                  <KeyboardArrowDownIcon sx={{ ml: 1 }} />
                </>
              )}
            </>
          ) : (
            <Styled.ButtonView>
              <Styled.Button onClick={() => nav('/login')} style={{ marginRight: 12 }}>
                Log In
              </Styled.Button>
              <Styled.Button onClick={() => nav('/signup')}>Sign Up</Styled.Button>
            </Styled.ButtonView>
          )}

          {showDropdown && (
            <Styled.Dropdown>
              <Styled.DropdownItem onClick={() => nav(`/gallery/${getLoggedInUser().id}`)}>
                <Styled.DropdownImage src={grid} alt="Gallery" /> Gallery
              </Styled.DropdownItem>
              {userType !== 'Default' && (
                <Styled.DropdownItem onClick={() => nav('/referrals')}>
                  <Styled.DropdownImage src={ReferralsIcon} alt="Referrals" /> Referrals
                </Styled.DropdownItem>
              )}

              <Styled.DropdownItem onClick={() => nav('/settings')}>
                <Styled.DropdownImage src={ASSETS.settings} alt="Settings" />
                Settings
              </Styled.DropdownItem>
              <Styled.DropdownItem onClick={handleLogout}>
                <Styled.DropdownImage src={log_out} alt="Logout" /> Log Out
              </Styled.DropdownItem>
            </Styled.Dropdown>
          )}
        </Styled.UserContainer>
      </Styled.RightContainer>
      <NewWheelPopup
        openWheelPopup={openWheelPopup}
        handleCloseWheelPopup={handleCloseWheelPopup}
      />
      <FeedbackModal
        openFeedbackModal={openFeedbackModal}
        setOpenFeedbackModal={setOpenFeedbackModal}
      />
      <WaitlistFormModal open={openWaitlistModal} onClose={() => setOpenWaitlistModal(false)} />
    </Styled.Container>
  );
};

export default Navbar;
